import * as escPos from "./escPos";

export default function () {
  let commands = [];
  escPos.reset(commands);
  escPos.openCashDrawer(commands);

  return escPos.encode(commands);
}
